export default function Redialling () {
  return <>
    <div className='begin box'>
      <h2 className='no-margin-bottom'>{ i18n.t('user.campaigns.phone.about_to_connect') }</h2>
    </div>
  </>
}
